import { render } from "./template.html?vue&type=template&id=0469c652&scoped=true"
import script from "./posts.vue?vue&type=script&lang=js"
export * from "./posts.vue?vue&type=script&lang=js"

import "./style.scss?vue&type=style&index=0&id=0469c652&lang=scss&scoped=true"

import exportComponent from "/mnt/d/_projects/gitogram/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0469c652"]])

export default __exports__